import React from "react";
import ReactDOM from "react-dom";
import SSOAccountApproval from "./SSOAccountApproval.jsx";

export function initSSOAccountApproval() {
  document.querySelectorAll(".js-sso-account-approval").forEach((mount, i) => {
    ReactDOM.render(<SSOAccountApproval />, mount);
  });
}
